import {
  Environment,
  devAgoraAppId,
  devSupersetDomain,
  mapTilerKey,
  devSupersetDashboardIds,
  stagingApiUrl,
  stagingWsDomain,
  prodFirebaseConfig,
  prodFirebaseVapidKey,
  prodFirebaseTokenId,
  stagingFacebookConfigId,
} from ".";

export const environment: Environment = {
  env: "staging",
  production: false,
  firebaseConfig: prodFirebaseConfig,
  firebaseVapidKey: prodFirebaseVapidKey,
  sentryDsn:
    "https://129221559daee187358a59380af2b2a1@o1211156.ingest.us.sentry.io/4506969796378624",
  sentryWhitelistHosts: [
    "staging.jugl.com",
    /jugl-staging-org-web-rc-\d+-\d+-\d+.netlify.app/g,
  ],
  apiUrl: stagingApiUrl,
  wsDomain: stagingWsDomain,
  firebaseTokenId: prodFirebaseTokenId,
  mapTilerKey,
  geocodingKey: atob("QUl6YVN5RFFBMGRkUEl1MGEwcG83U3J5eVRRS3NGMWFaQ1lpMHk4"),
  agoraAppId: devAgoraAppId,
  chatBotToken:
    "9BqDM5iVLw5u8mLJIztw.zu8dg5RWnZ5NZgihrxAtBixmXBOwZi7BmM2G9rD2UXvqyA35kEOip0pXjTjgvtKoA==",
  supersetDomain: devSupersetDomain,
  supersetDashboardIds: devSupersetDashboardIds,
  supersetChartIdToType: { 114: "tasks", 117: "people", 122: "travelLog" },
  isReCaptchaEnabled: true,
  reCaptchaKey: "6LdMnvopAAAAAID5SLUbjhOfVLc2BDzMlvJPr3nn",
  guestUrl: "https://guest-staging.jugl.com",
  facebookConfigId: stagingFacebookConfigId,
  featureFlags: {
    maxChatAttachmentsCount: 10,
  },
  demoToken: "",
  instagramClientId: "1208905981101498",
  chatBotUrl: "https://jugl-chat-bot-staging.netlify.app",
  escapeChatChars: true,
};
